import { useEffect, useId, useRef } from 'react';
import { t } from '../../i18n';
import { useToast } from '../../lib/toast';
import { canShowPdf, PdfPages } from '../../components/Pdf';
import { isPreviewImage, saveLoadedFile, type LoadedFile } from './common/files';
import { ShareFile } from '../../components/ShareFile';

// Datei aus dem Chat ansehen (Blatt von unten, am Desktop mittig): Vorschau und Speichern.
export function FileSheet({ file, onClose }: { file: LoadedFile & { meta: string }; onClose(): void }) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  const toast = useToast();
  const name = file.file.name;
  const image = file.file.mime.startsWith('image/');
  const pdf = file.file.mime === 'application/pdf';

  useEffect(() => {
    const d = ref.current;
    if (d && !d.open) d.showModal();
  }, []);

  return (
    <dialog
      ref={ref}
      className="chat-sheet"
      aria-labelledby={titleId}
      onClose={onClose}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
    >
      <div className="sheet">
        <div className="sheet-top">
          <b id={titleId}>{name}</b>
          <button type="button" className="x" aria-label={t('Schließen')} onClick={onClose}>
            ×
          </button>
        </div>
        <div className="meta">{file.meta}</div>
        {isPreviewImage(file.file.mime) ? (
          <img className="previmg" src={file.url} alt={name} />
        ) : pdf && canShowPdf() ? (
          <object data={file.url} type="application/pdf" className="chat-pdf" aria-label={name}>
            <Paper name={name} />
          </object>
        ) : pdf ? (
          <div className="chat-pdf">
            <PdfPages url={file.url} title={name} fallback={<Paper name={name} />} />
          </div>
        ) : (
          <Paper name={name} />
        )}
        <div className="bwa-row">
          <button
            type="button"
            className="btn2 dark"
            onClick={() => {
              saveLoadedFile(file);
              toast(t('Datei gespeichert'));
            }}
          >
            {image ? t('Bild herunterladen') : t('PDF herunterladen')}
          </button>
          <ShareFile url={`${file.src}${file.src.includes('?') ? '&' : '?'}download=1`} name={name} />
        </div>
        <div className="src">{name}</div>
      </div>
    </dialog>
  );
}

function Paper({ name }: { name: string }) {
  return (
    <div className="preview">
      <div className="paper">
        <b>{name}</b>
        <i />
        <i style={{ width: '70%' }} />
        <i />
      </div>
    </div>
  );
}
